module.exports = __webpack_public_path__ + "static/rf-screenshot-notifications-63fb959acd439bd37dbb28e1528987c7.jpg";